import apiClient from "./apiClient";

const VID_KEY = "tb_vid";
const ATTR_KEY = "tb_attr";

function getVisitorId() {
  let id = localStorage.getItem(VID_KEY);
  if (!id) {
    id = "v_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(VID_KEY, id);
  }
  return id;
}

const SEARCH = ["google.", "bing.", "duckduckgo.", "yahoo.", "yandex.", "baidu.", "ecosia.", "brave."];
const SOCIAL = ["t.co", "twitter.", "x.com", "linkedin.", "lnkd.in", "facebook.", "fb.", "reddit.", "youtube.", "youtu.be", "instagram.", "pinterest.", "tiktok.", "ycombinator.", "producthunt."];

function hostOf(url) {
  if (!url) return "";
  try {
    return new URL(url).hostname.replace(/^www\./, "").toLowerCase();
  } catch {
    return "";
  }
}

function classify(referrer, src, med) {
  med = (med || "").toLowerCase();
  src = (src || "").toLowerCase();
  if (["cpc", "ppc", "paid", "display", "banner"].includes(med) || med.includes("ad")) return "Ads";
  if (["email", "newsletter"].includes(med) || ["email", "newsletter"].includes(src)) return "Email";
  if (src || med) {
    if (["twitter", "x", "linkedin", "facebook", "reddit", "instagram", "producthunt"].some((s) => src.includes(s))) return "Social";
    return "Referral";
  }
  const host = hostOf(referrer);
  if (!host || host === hostOf(window.location.href)) return "Direct";
  if (SEARCH.some((h) => host.includes(h))) return "Organic search";
  if (SOCIAL.some((h) => host.includes(h))) return "Social";
  return "Referral";
}

// Fire a pageview beacon and persist first-touch attribution for signup conversion.
export function trackVisit(path) {
  try {
    const params = new URLSearchParams(window.location.search);
    const referrer = document.referrer || "";
    const utm_source = params.get("utm_source") || "";
    const utm_medium = params.get("utm_medium") || "";
    const utm_campaign = params.get("utm_campaign") || "";
    const p = path || window.location.pathname || "/";

    // store first-touch attribution once
    if (!localStorage.getItem(ATTR_KEY)) {
      const attr = {
        channel: classify(referrer, utm_source, utm_medium),
        referrer_host: hostOf(referrer),
        utm_source,
        utm_campaign,
        landing: p,
      };
      localStorage.setItem(ATTR_KEY, JSON.stringify(attr));
    }

    apiClient.post("/track/visit", {
      path: p,
      referrer,
      utm_source,
      utm_medium,
      utm_campaign,
      visitor_id: getVisitorId(),
    }).catch(() => {});
  } catch {
    /* analytics must never break the page */
  }
}

export function getAttribution() {
  try {
    return JSON.parse(localStorage.getItem(ATTR_KEY) || "null");
  } catch {
    return null;
  }
}
